var map = {
	"./accumulate.png": 474,
	"./aquatic.png": 933,
	"./benefits.png": 475,
	"./buy-table.png": 934,
	"./claim-img.png": 476,
	"./claim-portal.png": 477,
	"./drawer-border.png": 935,
	"./free-claim.png": 478,
	"./glacial.png": 936,
	"./golem.png": 937,
	"./human-img.png": 479,
	"./inferno.png": 938,
	"./land-active-stepper.png": 939,
	"./land-definition-bg-1.png": 940,
	"./land-definition-bg.png": 941,
	"./land-drawer-img--earth.png": 480,
	"./land-drawer-img--fire.png": 481,
	"./land-drawer-img--ice.png": 482,
	"./land-drawer-img--water.png": 483,
	"./land-earth.png": 484,
	"./land-fight.png": 485,
	"./land-fire.png": 486,
	"./land-ice.png": 487,
	"./land-map.png": 942,
	"./land-mint-1st-bg.png": 943,
	"./land-placeholder.png": 488,
	"./land-stepper.png": 944,
	"./land-water.png": 489,
	"./map/aquatic.png": 945,
	"./map/base.png": 946,
	"./map/glacial.png": 947,
	"./map/golem.png": 948,
	"./map/inferno.png": 949,
	"./mint-btn.png": 460,
	"./orc_bg.png": 490,
	"./perk-generation.png": 491,
	"./shadow.png": 950,
	"./table-bg.png": 951,
	"./trait/aquatic/background_1.png": 649,
	"./trait/aquatic/base_1.png": 650,
	"./trait/aquatic/base_2.png": 952,
	"./trait/aquatic/decoa_1.png": 651,
	"./trait/aquatic/mainbuilding_1.png": 652,
	"./trait/aquatic/mainbuilding_2.png": 953,
	"./trait/aquatic/pet_1.png": 653,
	"./trait/aquatic/pet_2.png": 954,
	"./trait/aquatic/subbuildinga_1.png": 654,
	"./trait/aquatic/subbuildingb_1.png": 655,
	"./trait/glacial/background_1.png": 656,
	"./trait/glacial/base_1.png": 657,
	"./trait/glacial/base_2.png": 955,
	"./trait/glacial/decoa_1.png": 658,
	"./trait/glacial/mainbuilding_1.png": 659,
	"./trait/glacial/mainbuilding_2.png": 956,
	"./trait/glacial/pet_1.png": 660,
	"./trait/glacial/pet_2.png": 957,
	"./trait/glacial/subbuildinga_1.png": 661,
	"./trait/glacial/subbuildingb_1.png": 662,
	"./trait/golem/background_1.png": 663,
	"./trait/golem/base_1.png": 664,
	"./trait/golem/base_2.png": 958,
	"./trait/golem/decoa_1.png": 665,
	"./trait/golem/mainbuilding_1.png": 666,
	"./trait/golem/mainbuilding_2.png": 959,
	"./trait/golem/pet_1.png": 667,
	"./trait/golem/pet_2.png": 960,
	"./trait/golem/subbuildinga_1.png": 668,
	"./trait/golem/subbuildingb_1.png": 669,
	"./trait/inferno/background_1.png": 670,
	"./trait/inferno/base_1.png": 671,
	"./trait/inferno/base_2.png": 961,
	"./trait/inferno/decoa_1.png": 672,
	"./trait/inferno/mainbuilding_1.png": 673,
	"./trait/inferno/mainbuilding_2.png": 962,
	"./trait/inferno/pet_1.png": 674,
	"./trait/inferno/pet_2.png": 963,
	"./trait/inferno/subbuildinga_1.png": 675,
	"./trait/inferno/subbuildingb_1.png": 676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2154;